<template>
  <v-dialog v-model="dialog" max-width="765" @input="beforeClose">
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined color="#E03210" v-bind="attrs" class="button-height" v-on="on">remover alguns dados</v-btn>
    </template>
    <v-card class="data-remove-modal pt-2 pb-3">
      <v-card-title>
        <p class="titulo mb-0" :style="{ color: getAssets && getAssets.color ? getAssets.colors.primaryButtonBackground : '' }">Deleção de dados</p>
        <v-flex class="close-dialog">
          <v-btn icon @click="dialog = false"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text v-if="hideContact">
        <div class="texto">
          <p>
            Esses são os dados que podem ser removidos do seu cadastro sem afetar o uso do clube. Se você deseja deletar mais dados além desses, é necessário
            que você entre na opção SAIR DO CLUBE.
          </p>
        </div>

        <strong class="mt-3 mb-2">Selecione os dados que gostaria de remover:</strong>
        <div class="checkbox-container">
          <div v-for="checkboxData in getCheckboxData" :key="checkboxData.value">
            <v-checkbox
              v-model="checkbox"
              :disabled="!email || checkboxData.disabled"
              :value="checkboxData.value"
              :label="checkboxData.label"
              :color="getAssets.colors.form.buttonBackground"
            />
          </div>
        </div>
        <strong class="mb-2">Informe o e-mail pelo qual te atualizaremos sobre a sua solicitação:</strong>
        <v-text-field
          v-model="email"
          outlined
          label="E-mail"
          type="text"
          class="mb-2"
          name="email"
          :error-messages="error"
          :hide-details="!error"
          @blur="validateField"
        />
        <div class="mb-5">
          <span class="link" @click="hideContact = false">Eu não possuo endereço de e-mail</span>
        </div>
        <strong class="mb-2">Motivo da solicitação:</strong>
        <v-textarea
          v-model="motive"
          outlined
          label="Descreva o motivo da sua solicitação"
          class="mb-2"
          rows="3"
          :color="getAssets.colors.form.buttonBackground"
        />
        <v-btn
          class="button-height"
          :loading="btnLoading"
          :disabled="!email || checkbox.length < 1 || !motive || !!error"
          :width="isMobile ? '100%' : ''"
          :class="isMobile ? 'mb-3' : 'mr-5'"
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonFont }"
          @click="deleteData"
          >Confirmar solicitação</v-btn
        >
        <v-btn class="button-height" :width="isMobile ? '100%' : ''" text color="#B3280D" @click="dialog = false">cancelar</v-btn>
      </v-card-text>
      <contact-content v-else />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'DataRemoveModal',
  components: {
    ContactContent: () => import('@/modules/units/views/components/ContactContent.vue')
  },
  props: ['userEmail'],
  data: () => ({
    dialog: false,
    checkbox: [],
    email: '',
    motive: '',
    hideContact: true,
    btnLoading: false,
    error: ''
  }),
  computed: {
    ...mapGetters(['GET_ASSETS', 'USER_INFO']),
    getAssets() {
      return this.GET_ASSETS
    },
    getUser() {
      return this.USER_INFO
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
    getCheckboxData() {
      const data = [
        {
          value: 'email',
          label: 'E-mail',
          disabled: !this.getUser.email
        },
        {
          value: 'address',
          label: 'Endereço',
          disabled: !this.getUser.address || !this.getUser.address.postal_code
        }
      ]
      if (!this.$route.query.cnpj) {
        data.push(
          {
            value: 'gender',
            label: 'Gênero',
            disabled: !this.getUser.gender
          },
          {
            value: 'birth_date',
            label: 'Data de nascimento',
            disabled: !this.getUser.birth_date || this.getUser.birth_date === 'Invalid date'
          }
        )
      }
      return data
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue && this.getUser.email) this.email = this.getUser.email
    }
  },
  methods: {
    ...mapActions(['createDeleteDataRequest']),
    beforeClose() {
      this.hideContact = true
      this.checkbox = []
      this.email = ''
      this.motive = ''
      this.error = ''
    },
    deleteData() {
      this.btnLoading = true
      this.createDeleteDataRequest({ email: this.email, data: this.checkbox, motive: this.motive })
        .then(() => {
          this.$router.push({ name: 'solicitacao-realizada', params: { all: false } })
        })
        .catch(err => {
          const error = err['response'].errors[0]
          const pendingRequestMessageError = 'This user already has a pending delete data request'
          let errorMessage = 'Ocorreu um erro. Tente novamente mais tarde'
          if (pendingRequestMessageError === error.message) {
            errorMessage = 'Já existe uma solicitação de exclusão de dados pendente'
          }
          this.$snackbar({
            message: errorMessage,
            snackbarColor: 'error'
          })
          console.error(err)
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    validateField() {
      this.error = ''
      this.$validator.validate('email', this.email).then(valid => {
        if (!this.email || !valid) {
          this.error = 'Esse campo precisa ter um e-mail válido.'
          return
        }
        this.error = ''
      })
    }
  }
}
</script>

<style lang="scss">
$tablet-size: 960px;

.data-remove-modal {
  & .v-card__text {
    max-width: calc(100% - 30px);
  }
  & .titulo {
    font-family: 'Roboto', medium;
    font-weight: 500;
    font-size: 20px;
  }
  & .texto {
    & p {
      margin: 0;
      text-align: left;
      font-family: 'Roboto', sans-serif;
      font-size: 14px !important;
      color: #6b7580;
      line-height: 150%;
      max-width: 100%;
    }
  }
  & .fechar {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px !important;
    line-height: 16px !important;
    text-align: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }

  & .close-dialog {
    text-align: right;
  }

  & strong {
    color: #4b525a;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    display: block;
  }

  & .checkbox-container {
    display: grid;
    grid-template-columns: repeat(4, 150px);

    & span {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 22px;
      line-height: 26px;
    }
    & .v-input--selection-controls {
      margin-top: 0px !important;
    }
    & .v-messages__message {
      display: none;
    }

    & label {
      font-size: 13px;
    }
  }

  & .link {
    font-size: 14px;
    color: #0079f2;
    cursor: pointer;
    text-decoration: underline;
  }
}

@media screen and (max-width: 725px) {
  .data-remove-modal {
    & .checkbox-container {
      grid-template-columns: 1fr;
    }
  }
}
</style>
